import { Gender } from "@dcc/types/gender";
import { getTips } from "drinkaware-tools-api-library";
import { Activity } from "@dcc/types/activity";
import { ActivityCategory } from "@dcc/types/activityCategory";
import { GenderString, Score } from "drinkaware-tools-api-library";
import { TipsResponseContentItem } from "drinkaware-tools-api-library/dist/src/clients/content/src/models";
import { contentApi } from "@dcc/api";
const FOUR_DAYS_OR_MORE = "4+";
const THREE_DAYS_OR_LESS = "3-";

export const getActivities = async (
  gender: Gender,
  numberDrinkingDays: number
): Promise<Activity[]> => {
  const score = numberDrinkingDays < 4 ? THREE_DAYS_OR_LESS : FOUR_DAYS_OR_MORE;

  try {
    const response = await getTips({
      content: contentApi,
      gender: Gender[gender] as GenderString,
      score: score as Score
    });

    if (response.success && response.content !== undefined) {
      return convertTipsToActivities(response.content);
    } else {
      // eslint-disable-next-line
      console.log("getActivities: received failure response.");
    }
  } catch (e) {
    //eslint-disable-next-line
    console.log("getActivities: An unexpected error has occurred. ", e);
  }
  return [];
};

const mapCategory: {
  [index: string]: ActivityCategory;
} = {
  ["easy tips"]: ActivityCategory.EasyTips,
  ["active days"]: ActivityCategory.ActiveDays,
  ["health"]: ActivityCategory.Health
};

export const convertTipsToActivities = (
  tips: TipsResponseContentItem[]
): Activity[] =>
  tips.map(({ id, title, text, imageUrl, videoUrl, category }) => {
    return {
      id: id.toString(),
      title,
      text,
      image: imageUrl,
      videolink: videoUrl,
      category: mapCategory[category.toLowerCase()]
    };
  });
